export default __webpack_public_path__ + "static/cost-icn2-8b96114121f9a0d7d6d375e4ea176aa7.png";